import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { LostChangesVisitModal } from '@components/LostChangesVisitModal';
import { addModal, removeModal } from '@state-mgmt/slices/appSlice';

export const useLostChangesVisitModal = () => {
  const modalKey = 'lost-changes-visit-modal';
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(removeModal({ key: modalKey }));
  }, [dispatch]);

  const displayModal = useCallback(
    (onCancel: () => void) => {
      const children = <LostChangesVisitModal onCancel={onCancel} onClose={onClose} />;
      dispatch(addModal({ key: modalKey, props: { visible: true, children, onClose } }));
    },
    [dispatch, onClose]
  );

  return { displayModal };
};
